<template>
    <div id="menu" class="wrapper">
        <Heading title="Ons Menu" subtitle="Little Asia" />
        <button
           class="badge"
           :class="{active: !isTakeAway}"
           @click="isTakeAway = false"
        >
          Restaurant menu
        </button>
        <button
            class="badge"
            :class="{active: isTakeAway}"
            @click="isTakeAway = true"
        >
          Afhaal / Bezorg menu
        </button>
        <MenuWrapper :categories="categories" :dishes="dishes" />
    </div>
</template>

<script>
import Heading from '@/components/sections/Heading'
import MenuWrapper from '@/components/menu/MenuWrapper'

import Categories from '@/assets/json/menu-categories.json'
import TakeAwayCategories from '@/assets/json/menu-takeaway-categories.json'

import Dishes from '@/assets/json/menu-dishes.json'
import TakeAwayDishes from '@/assets/json/menu-takeaway.json'

export default {
    components: {
        Heading,
        MenuWrapper,
    },
    data() {
      return {
        isTakeAway: false,
      }
    },
    computed: {
      categories() {
        if(!this.isTakeAway) {
          return Categories
        }
        return TakeAwayCategories
      },
      dishes() {
        if(!this.isTakeAway) {
          return Dishes
        }
        return TakeAwayDishes
      }
    },
}
</script>

<style lang="scss" scoped>
    .wrapper {
        margin: 0;
        padding: 2rem;
        text-align: center;
        background-color: rgb(255, 254, 245);
        .badge {
          margin-bottom: 15px;
          display: inline-block;
          margin-top: 10px;
          padding: 10px;
          font-weight: bold;
          border-radius: 6px;
          text-align: center;
          border: 1px solid #e74c3c;
          color: #e74c3c;
          background-color: transparent;
          &.active {
            background-color: #e74c3c;
            color: white;
          }
          &:hover {
            cursor: pointer;
          }
        }
    }

@media screen and (max-width: 600px) {
.wrapper {
        padding: 0.5rem;
        padding-top: 2em;
    }
}
</style>
